export interface IDripFeederSource {
  id?: string;
  sourceId: string;
  order?: number | null;
  maxPulls?: number;
  isRankedSource?: boolean;
  sourceName?: string;
  isSecondary?: boolean;
  isIgnored?: boolean;
}

export interface IDripFeeder {
  id?: string;
  rank: number;
  name: string;
  sources: IDripFeederSource[] | null;
  roleId: string;
  maxPulls: number;
  minutesBetweenPulls: number;
  pullNewestFirst: boolean;
  useSourceWithLowestCountFirst: boolean;
  isFronterSet: boolean;
}

interface ICreatedBy {
  id: string;
  email: string;
  name: string;
}

export interface ISources {
  id: string;
  name: string;
  description: string;
  isSecondary: boolean;
  allowSecondary: boolean;
  isAutoResponseEnabled: boolean;
  autoResponsePostUrl: string;
  autoResponseVersion: number;
  enableCamRef: boolean;
  isAutoDeadEnabled: boolean;
  isAutoDelayedResponseEnabled: boolean;
  autoDeadDelayedResponse: number;
  autoDelayedResponseOfferCallbackBaseUrl: string;
  createdBy: ICreatedBy;
  createdDate: Date;
}

export enum DripFeederGridTypes {
  ranked = 'ranked',
  ignored = 'ignored',
  other = 'other'
}
